import React from 'react';
import { useParams, Link } from 'react-router-dom';

interface Product {
  id: string;
  name: string;
  image: string;
  description: string;
}

function ProductPage({ products }: { products: Product[] }) {
  const { id } = useParams();
  const product = products.find((p: Product) => p.id === id);

  const productList = [
    {
      id: 'panangarkandu',
      name: 'பனங்கற்கண்டு',
      image: '/Sugar.jpg',
      description: `
      * ஆற்றல்: விரைவான ஆற்றல் ஊக்கத்தை வழங்குகிறது
      * இரத்த சர்க்கரை: இரத்த சர்க்கரை அளவை ஒழுங்குபடுத்துகிறது
      * செரிமானம்: செரிமானத்தை மேம்படுத்துகிறது மற்றும் குடல் பாதையை சுத்தப்படுத்துகிறது
      * நோய் எதிர்ப்பு சக்தி: நோய் எதிர்ப்பு சக்தியை அதிகரிக்கிறது
      * வயதான எதிர்ப்பு: செல்களில் ஃப்ரீ ரேடிக்கல் குவிவதைக் குறைத்து, செல் சேதம் மற்றும் வயதானதைக் கடக்கிறது.
      * பல் ஆரோக்கியம்: வேறு சில இனிப்புகளைப் போல பல் சிதைவுக்கு பங்களிக்காது.
      * இருமல் மற்றும் சளி: தொண்டை வலியைத் தணித்து இருமல் அறிகுறிகளைக் குறைக்கிறது
      * நீர்ச்சத்து இழப்பு: தாகத்தைத் தணித்து, நீர்ச்சத்தை நீக்குகிறது
      * இரத்த அழுத்தம்: இரத்த அழுத்தத்தைக் கட்டுப்படுத்துகிறது
    `
    },
    {
      id: 'herbal_product_1',
      name: 'New Herbal Product',
      image: '/IMG_4809.JPG',
      description: 'A powerful herbal remedy that supports digestion and overall well-being.',
    },
    {
      id: 'herbal_product_2',
      name: 'Herbal Medicine 2',
      image: '/IMG_4818.JPG',
      description: 'Traditional medicine for immune system support.',
    },
    {
      id: 'herbal_product_3',
      name: 'Herbal Medicine 3',
      image: '/IMG_4817.JPG',
      description: 'Traditional medicine for immune system support.',
    }
  ];

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-green-500 to-yellow-600 p-8">
      <h1 className="text-3xl font-bold text-white mb-6">Our Products</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl w-full">
        {productList.map((item) => (
          <div key={item.id} className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-xl font-bold text-gray-900">{item.name}</h2>
            <img src={item.image} alt={item.name} className="w-full h-48 object-cover rounded-lg my-4" />
            <p className="text-gray-700">{item.description}</p>
            <button className="mt-4 px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-400 shadow-md">
              Buy Now
            </button>
          </div>
        ))}
      </div>
      <div className="text-center mt-6">
        <Link to="/" className="px-6 py-2 bg-gradient-to-r from-yellow-400 to-red-500 text-white rounded-lg hover:from-red-500 hover:to-yellow-400 animate-pulse shadow-lg text-lg font-bold">Back to Home</Link>
      </div>
    </div>
  );
}

export default ProductPage;
